
import { useState } from "react";
import { LostItem } from "@/types";

export const useLostFoundModals = () => {
  const [newItemOpen, setNewItemOpen] = useState(false);
  const [editItemOpen, setEditItemOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<LostItem | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  const [signatureModalOpen, setSignatureModalOpen] = useState(false);
  const [timelineModalOpen, setTimelineModalOpen] = useState(false);
  const [infoModalOpen, setInfoModalOpen] = useState(false);

  return {
    newItemOpen,
    setNewItemOpen,
    editItemOpen,
    setEditItemOpen,
    selectedItem,
    setSelectedItem,
    deleteDialogOpen,
    setDeleteDialogOpen,
    discardDialogOpen,
    setDiscardDialogOpen,
    signatureModalOpen,
    setSignatureModalOpen,
    timelineModalOpen,
    setTimelineModalOpen,
    infoModalOpen,
    setInfoModalOpen,
  };
};
